<template>
  <module-block
    class="home-faq"

    block="lightest"
  >
    <div class="home-faq__inner group group--first-last">
      <h2 class="h2 heading">{{ heading }}</h2>
      <div
        v-for="(faq, index) in faqs"
        :key="index"
        class="home-faq__block"
      >
        <h4 class="h4 heading home-faq__question">{{ faq.question }}</h4>
        <p class="p faq__answer"> {{ faq.answer }}</p>
      </div>
    </div>
  </module-block>
</template>

<script>
// Modules
import ModuleBlock from 'modules/Block';

export default {
  name: `home-faqs`,

  // Components
  components:  {
    ModuleBlock,
  },

  data () {
    return {
      heading: `Frequently Asked Questions`,
      faqs: [
        {
          question: `Are my X-rays safe with VeriTooth?`,
          answer: `The VeriTooth process is safe, secure, and confidential. Your request and files are scrubbed of any identifying information and submitted to qualified dentists for an unbiased review. All data is stored in a secure environment.`,
        },
        {
          question: `Who reviews my VeriTooth request?`,
          answer: `The VeriTooth review team consists of a group of dentists and dental specialists who want to highlight quality and transparency in the dental industry. All reviewers’ credentials have been validated by VeriTooth and their reviews are regularly checked by industry peers. In addition to trusted experts, VeriTooth has pulled together research and best practices that all reviewers use to verify the quality of the work. These best practices have been adopted by both the ADA (American Dental Association) and the AAE (American Association of Endodontists), experts in root canals.`,
        },
        {
          question: `Is an X-ray enough to prove good/bad dentistry?`,
          answer: `In short, no. An x-ray is not enough to determine the overall care a patient receives. By reviewing a before and after x-ray VeriTooth is basically performing a "spot check." Nothing replaces a full consultation and the x-ray definitely doesn’t show everything. The x-rays are one data point to help patients and dentists jointly assess quality.`,
        },
        {
          question: `What about other procedures?`,
          answer: `Right now VeriTooth is launching with a focus on root canals. But we definitely plan to offer additional review capabilities in the future including crowns, fillings and extractions.`,
        },
        {
          question: `Why is VeriTooth free?`,
          answer: `VeriTooth is currently testing our service with patients and doctor’s offices to identify any potential issues before we launch more publicly in the coming months.`,
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// Faqs.vue?5b14fb2e